import React from 'react'
import { Route, Routes } from 'react-router'
import CampaignImportTypeForm from './CampaignImportType'
import GoogleAdsCampaignsImportForm from './GoogleAds'
import CampaignImportSuccess from './CampaignImportSuccess'
import MetaAdsCampaignsImportForm from './MetaAds'

export default function CampaignImportForm() {
  return (
    <Routes>
      <Route path={'/'} element={<CampaignImportTypeForm />} />
      <Route path={'google-ads'} element={<GoogleAdsCampaignsImportForm />} />
      <Route path={'facebook-ads'} element={<MetaAdsCampaignsImportForm />} />
      <Route path={'success'} element={<CampaignImportSuccess />} />
    </Routes>
  )
}
